var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlidersSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12602 9L3 9C2.44772 9 2 8.55229 2 8C2 7.44772 2.44772 7 3 7H4.12602C4.57006 5.27477 6.13616 4 8 4C9.86384 4 11.4299 5.27477 11.874 7H21C21.5523 7 22 7.44772 22 8C22 8.55228 21.5523 9 21 9L11.874 9C11.4299 10.7252 9.86384 12 8 12C6.13616 12 4.57006 10.7252 4.12602 9ZM6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.126 15C12.5701 13.2748 14.1362 12 16 12C17.8638 12 19.4299 13.2748 19.874 15H21C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17H19.874C19.4299 18.7252 17.8638 20 16 20C14.1362 20 12.5701 18.7252 12.126 17L3 17C2.44772 17 2 16.5523 2 16C2 15.4477 2.44772 15 3 15H12.126ZM16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidersSimple);
export default __webpack_public_path__ + "static/media/sliders-simple.b386df9be2109c6bf87bd2db4fe75150.svg";
export { ForwardRef as ReactComponent };